module.exports = __webpack_public_path__ + "69a852cf8bbd9661548641d5628a560d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-8.jpg
// module id = 1181
// module chunks = 0